const WSS_URL = 'wss://localhost:65469/ws'
var socket = null
var isWebSocketOpen = false

export default {

  open() {
    try {
      socket = new WebSocket(WSS_URL)
      isWebSocketOpen = true
      console.log('WebSocket has been successfuly opened.')
      console.log(socket)
      return socket
    } catch (e) {
      console.log(e)
    }
  },

  close() {
    try {
      if (isWebSocketOpen) {
        socket.close()
        isWebSocketOpen = false
        console.log('WebSocket has been successfuly closed.')
        console.log(socket)
      }
    } catch (e) {
      console.log(e)
    }
  },

  initFingerPrintCapture(cpf, fingerIndex) {
    if (!isWebSocketOpen) {
      return 'WebSocket has to be opened!'
    }

    if (!cpf) {
      return 'CPF property must be informed!'
    }

    if (!fingerIndex) {
      return 'Finger index property must be informed!'
    }

    var obj = '{"finger":"' + fingerIndex + '","cpf":"' + cpf + '","command":"START_FINGER_CAPTURE","preview":"true"}'
    socket.send(obj)
  }
}



// WEBPACK FOOTER //
// ./src/biometrics/index.js